export const FILLER_PRODUCTS = [
  { name: 'Vanilla Sponge Cake 8"', unitPrice: 12.50, vatRate: 0 },
  { name: 'Chocolate Gateau Box', unitPrice: 18.00, vatRate: 0 },
  { name: 'Cupcake Box x12', unitPrice: 14.00, vatRate: 0 },
  { name: 'Fondant Icing 1kg', unitPrice: 6.50, vatRate: 20 },
  { name: 'Edible Gold Dust 5g', unitPrice: 8.99, vatRate: 20 },
  { name: 'Cake Board Set', unitPrice: 3.50, vatRate: 20 },
  { name: 'Almond Croissant x6', unitPrice: 9.00, vatRate: 0 },
  { name: 'Sourdough Loaf', unitPrice: 4.50, vatRate: 0 },
  { name: 'Baklava Tray x12', unitPrice: 15.00, vatRate: 0 },
  { name: 'Brownie Tray x16', unitPrice: 14.00, vatRate: 0 },
  { name: 'Swiss Roll 400g', unitPrice: 5.50, vatRate: 0 },
  { name: 'Celebration Cake 10"', unitPrice: 55.00, vatRate: 0 },
];

export const COMPANY_INFO = {
  name: 'FIS Suppliers LTD',
  tradingAs: 'The Cakery Suppliers',
  addressLine: '93 Lozells Road, Birmingham B19 2TR',
  phone: '07946579235',
  email: 'accounts@cakerysuppliers.co.uk',
  companyNo: '11369664',
  vatNo: '297604465',
  bank: {
    name: 'Barclays',
    accountName: 'FIS Suppliers LTD',
    accountNumber: '33731332',
    sortCode: '20-84-13',
  },
};

export const DEFAULT_DAILY_LIMIT = 1800;

export const DEFAULT_LIMITS = {
  monthlyMin: 45000,
  monthlyMax: 55000,
  weekdayMin: 500,
  weekdayMax: 3000,
  weekendMin: 400,
  weekendMax: 1200,
  dailyVatMin: 5,
  dailyVatMax: 10,
};
